export default {
  nav: { home: "Home", treatments: "Trattamenti", about: "Chi sono", studio: "Studio", contact: "Contatto" },
  cta: {
    book: "Prenota un appuntamento",
    discover: "Scopri i trattamenti",
    moreAbout: "Scopri di più su di me",
    allTreatments: "Tutti i trattamenti",
    send: "Invia richiesta",
    sending: "Invio in corso…",
    call: "Chiama ora",
    whatsapp: "Scrivi su WhatsApp",
    backHome: "Torna alla home",
    discoverStudio: "Scopri lo studio",
    request: "Richiedi un appuntamento",
    readMore: "Scopri di più",
  },
  header: { openMenu: "Apri il menu", closeMenu: "Chiudi il menu", languageLabel: "Scegli la lingua" },
  home: {
    heroEyebrow: "Beauty & Wellness · Basilea",
    heroLines: ["Bellezza.", "Relax.", "Benessere."],
    heroWelcomePre: "Benvenuta da",
    heroWelcomeBrand: "IMPERIUM.",
    heroSub: "Cosmetica professionale e massaggi rigeneranti per maggiore radiosità, calma e benessere.",
    heroQuote: "«Cura personale, trattamenti di alta qualità e un'atmosfera in cui puoi ritrovare completamente te stessa.»",
    trustNo: "01",
    trustEyebrow: "Fiducia",
    trustTitle: "La bellezza inizia con la fiducia.",
    trustText: "La tua pelle, il tuo corpo e il tuo benessere meritano attenzione. Da IMPERIUM si incontrano trattamento professionale, consulenza personale e un'atmosfera in cui puoi sentirti completamente a tuo agio.",
    trustPoints: ["Cura personale", "Trattamento individuale", "Atmosfera di alta qualità", "Cosmetica professionale", "Tempo per le tue esigenze"],
    servicesNo: "02",
    servicesEyebrow: "Trattamenti",
    servicesTitle: "Cosa desideri mettere al centro oggi?",
    servicesIntro: "Massaggi, cosmetica e styling – ogni trattamento è studiato individualmente per te.",
    auszeitNo: "03",
    auszeitEyebrow: "La tua pausa",
    auszeitTitle: "La tua pausa inizia nel momento in cui scegli te stessa.",
    auszeitText: "Lascia la quotidianità alle spalle per un momento. Percepisci calma, cura ed energia nuova – su misura per te.",
    ablaufEyebrow: "Come funziona",
    ablaufTitle: "Così inizia il tuo momento Imperium",
    steps: [
      { t: "Scegli il trattamento", d: "Scopri ciò che oggi può farti stare bene." },
      { t: "Mettiti in contatto", d: "Facilmente, tramite modulo, WhatsApp o telefono." },
      { t: "Ricevi una consulenza personale", d: "Tutto viene adattato a te e ai tuoi desideri." },
      { t: "Arriva rilassata", d: "Entri e la quotidianità resta fuori." },
      { t: "Goditi il trattamento", d: "Il tuo momento Imperium – tutto per te." },
    ],
    expertNo: "04",
    expertEyebrow: "La tua esperta",
    expertName: "Leidiane Alcântara",
    expertText: "Professionista dell'estetica e del benessere – con dedizione, formazione continua e uno sguardo attento alle esigenze individuali di ogni persona.",
    studioNo: "05",
    studioEyebrow: "Lo studio",
    studioTitle: "Uno spazio che nasce con amore per i dettagli.",
    studioText: "A Basilea sta nascendo IMPERIUM Beauty & Wellness – uno studio moderno, elegante e confortevole, creato per un'esperienza completa di bellezza, cura e benessere.",
    galleryEyebrow: "Galleria",
    galleryTitle: "Scorci dal mondo di IMPERIUM",
    finalTitle: "Pronta per la tua pausa più bella?",
    finalText: "Prenditi del tempo per te. Non vedo l'ora di conoscerti di persona.",
    marquee: ["Estetica", "Massaggi", "Linfodrenaggio", "Cura del viso", "Make-up", "Benessere"],
  },
  treatmentsPage: {
    eyebrow: "Trattamenti",
    title: "I tuoi trattamenti da IMPERIUM",
    intro: "Massaggi, cosmetica e styling – scopri ciò che oggi può farti stare bene. Ogni trattamento è studiato individualmente per te.",
    massage: "Massaggi & Corpo",
    beauty: "Cosmetica & Styling",
  },
  treatment: {
    back: "Tutti i trattamenti",
    related: "Altri trattamenti",
    ctaTitle: "Richiedi questo trattamento",
    ctaText: "Raccontami i tuoi desideri – ti consiglierò personalmente e troveremo insieme il tuo momento Imperium.",
  },
  about: {
    eyebrow: "Chi sono",
    title: "Leidiane Alcântara",
    role: "Estetica & Benessere",
    bio: [
      "Sono Leidiane Alcântara, professionista dell'estetica e del benessere – appassionata nel prendermi cura delle persone e nel far risplendere ciò che c'è di più bello in ognuna di loro.",
      "Con dedizione, formazione continua e uno sguardo attento alle esigenze individuali, ho costruito il mio percorso con tanto lavoro, responsabilità e amore per ciò che faccio.",
      "Credo che ogni persona sia unica. Per questo offro un'attenzione personalizzata, con tecniche moderne e sicure – sempre mettendo al primo posto la cura, l'estetica e il benessere.",
    ],
    storyEyebrow: "La storia",
    storyTitle: "Il sogno di IMPERIUM",
    story: [
      "Ora sto realizzando un grande sogno: apro IMPERIUM Beauty & Wellness – uno splendido studio, creato apposta per offrire un'esperienza completa di bellezza, cura e benessere.",
      "Ogni dettaglio viene preparato con tanto amore, affinché ogni cliente si senta accolta, valorizzata e viva un momento unico, in un ambiente moderno, elegante e confortevole.",
      "Sarà un luogo in cui estetica, relax e autostima si incontrano – perché prendermi cura di te è la mia missione più grande.",
    ],
    quote: "«Prendermi cura di te è la mia missione più grande.»",
    philosophyEyebrow: "Filosofia",
    philosophyTitle: "Ogni persona è unica.",
    philosophyText: "Cura personale, tecniche moderne e sicure – sempre con l'attenzione rivolta a cura, estetica e benessere.",
    ctaTitle: "Conosciamoci.",
    ctaText: "Non vedo l'ora di ricevere il tuo messaggio – personale, semplice e senza impegno.",
  },
  studio: {
    eyebrow: "Studio",
    title: "IMPERIUM a Basilea",
    intro: "Uno studio creato per la bellezza, la cura e il benessere – moderno, elegante e confortevole.",
    preparing: "Lo studio è attualmente in preparazione, con tanto amore per i dettagli. Ogni angolo nasce con l'obiettivo di farti sentire benvenuta e valorizzata fin dal primo momento.",
    locationLabel: "Posizione",
    location: "Austrasse 31, 4051 Basel, Switzerland",
    ctaTitle: "Partecipa fin dall'inizio.",
    ctaText: "Scrivimi – sarò felice di sentirti.",
  },
  contact: {
    eyebrow: "Contatto",
    title: "Il tuo momento Imperium inizia qui.",
    intro: "Domande, desideri o appuntamenti – scrivimi. Ti risponderò personalmente.",
    locationLabel: "Posizione",
    phoneLabel: "Telefono & WhatsApp",
    emailLabel: "E-mail",
    instagramLabel: "Instagram",
    formTitle: "Invia una richiesta",
  },
  form: {
    name: "Nome e cognome",
    email: "E-mail",
    phone: "Telefono (facoltativo)",
    treatment: "Trattamento",
    treatmentPlaceholder: "Seleziona un trattamento",
    noPreference: "Non ancora sicura / Consulenza",
    message: "Messaggio",
    messagePlaceholder: "Come posso aiutarti?",
    privacy: "Ho letto l'informativa sulla privacy e acconsento al trattamento dei miei dati per rispondere alla mia richiesta.",
    submit: "Invia richiesta",
    sending: "Invio in corso…",
    success: "Grazie mille! La tua richiesta è arrivata. Ti risponderò personalmente il prima possibile.",
    error: "Purtroppo si è verificato un errore. Riprova o scrivimi su WhatsApp.",
    required: "Compila tutti i campi obbligatori.",
    invalidEmail: "Inserisci un indirizzo e-mail valido.",
    privacyRequired: "Conferma l'informativa sulla privacy.",
  },
  footer: {
    tagline: "Estetica · Massaggi · Benessere",
    navTitle: "Navigazione",
    treatmentsTitle: "Trattamenti",
    contactTitle: "Contatto",
    legalTitle: "Note legali",
    impressum: "Impressum",
    privacy: "Privacy",
    rights: "Tutti i diritti riservati.",
    location: "Austrasse 31, 4051 Basel, Switzerland",
  },
  impressum: {
    title: "Impressum",
    operatorLabel: "Gestore",
    operator: "IMPERIUM Beauty & Wellness — Leidiane Alcântara",
    contactLabel: "Contatto",
    contentLabel: "Responsabile dei contenuti",
    note: "Le ulteriori informazioni legali sono in fase di completamento e saranno presto integrate.",
  },
  privacyPage: {
    title: "Informativa sulla privacy",
    responsibleTitle: "Titolare del trattamento",
    responsibleText: "IMPERIUM Beauty & Wellness — Leidiane Alcântara, Austrasse 31, 4051 Basel, Switzerland.",
    dataTitle: "Dati tramite il modulo di contatto",
    dataText: "Quando mi scrivi tramite il modulo, i tuoi dati (nome, e-mail, telefono, messaggio) vengono utilizzati esclusivamente per rispondere alla tua richiesta e non vengono trasmessi a terzi.",
    storageTitle: "Memorizzazione nel browser",
    storageText: "Questo sito salva solo la tua scelta della lingua e la tua decisione sui cookie nel tuo browser. Non vengono utilizzati cookie di tracciamento.",
    rightsTitle: "I tuoi diritti",
    rightsText: "Hai sempre diritto di accesso, rettifica o cancellazione dei tuoi dati. Scrivi semplicemente a kontakt@imperium-wellness.ch.",
  },
  google: { label: "IMPERIUM su Google", rate: "Valuta su Google", reviews: "Vedi le recensioni" },
  notfound: {
    title: "404",
    heading: "Questa pagina non è stata trovata.",
    text: "Forse qui trovi ciò che cerchi:",
  },
  cookie: {
    text: "Questo sito utilizza solo memorizzazioni tecnicamente necessarie – ad esempio per la tua scelta della lingua. Non vengono impostati cookie di tracciamento.",
    accept: "Ho capito",
    more: "Privacy",
  },
  seo: {
    homeTitle: "IMPERIUM Beauty & Wellness | Cosmetica, Estetica e Massaggi a Basilea",
    homeDesc: "Cosmetica professionale e massaggi rigeneranti per maggiore radiosità, calma e benessere. La tua bellezza. Il tuo momento. Il tuo Imperium.",
  },
};
